<template>
  <div
    id="mobile-menu-container"
    class="mobile-menu-container"
    :class="{ open: isMenuOpen }"
  >
    <div class="mobile-menu-header">
      <div class="mobile-menu-icon-container"></div>
      <div class="hamburguer-container">
        <div id="nav-icon3" :class="{ open: isMenuOpen }" @click="openMenu()">
          <span :style="'background-color:'+menuColor"></span>
          <span :style="'background-color:'+menuColor"></span>
          <span :style="'background-color:'+menuColor"></span>
          <span :style="'background-color:'+menuColor"></span>
        </div>
      </div>
    </div>
    <div class="mobile-menu-row">
      <div class="mobile-menu-options-container">
        <div
          @click="selectMobileOption('inicio')"
          :class="{ active: getActiveSection === 'inicio' }"
          class="mobile-menu-option"
        >
          <h2>Inicio</h2>
        </div>
        <div
          @click="selectMobileOption('ranking')"
          :class="{ active: getActiveSection === 'ranking' }"
          class="mobile-menu-option"
        >
          <h2>Ranking</h2>
        </div>
        <div
          @click="selectMobileOption('calendario')"
          :class="{ active: getActiveSection === 'calendario' }"
          class="mobile-menu-option"
        >
          <h2>Calendario</h2>
        </div>
        <div
          @click="selectMobileOption('reglamento')"
          :class="{ active: getActiveSection === 'reglamento' }"
          class="mobile-menu-option"
        >
          <h2>Reglamento</h2>
        </div>
        <div
          @click="selectMobileOption('draw')"
          :class="{ active: getActiveSection === 'draw' }"
          class="mobile-menu-option"
        >
          <h2>Draw</h2>
        </div>
        <div
          @click="selectMobileOption('contacto')"
          :class="{ active: getActiveSection === 'contacto' }"
          class="mobile-menu-option"
        >
          <h2>Contacto</h2>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
export default {
  name: "MobileMenu",
  computed: {
    ...mapGetters(["getActiveSection"]),
  },
  mounted(){
    const routeName = this.$route.name;
    this.menuColor = this.setColorByRouter(routeName)
  },
  methods: {
    ...mapActions({
      setActiveSection: "setActiveSection",
    }),
    openMenu() {
      this.isMenuOpen = !this.isMenuOpen;
    },
    selectHomeOption(option) {
      this.setActiveSection({
        willScroll: true,
        section: option,
      });
    },
    selectMobileOption(option) {
      this.setActiveSection({
        willScroll: true,
        section: option,
      });
      this.$router.push({ path: option }).catch(err => {
        // Ignore the vuex err regarding  navigating to the page they are already on.
        if (
          err.name !== 'NavigationDuplicated' &&
          !err.message.includes('Avoided redundant navigation to current location')
        ) {
          // But print any other errors to the console
          throw err;
        }
      });
      this.openMenu();
    },
    setColorByRouter(name) {
    switch (name) {
      case "banner":
        return "#FFF";
      case "ranking":
        return "#FFF";
      case "calendario":
        return "#FFF";
      case "reglamento":
        return "#FFF";
      case "draw":
        return "#FFF";
      case "contacto":
        return "#000";
      default:
        return "#FFF";
    }
  },
  },
  data() {
    return {
      isMenuOpen: false,
      menuColor: '#FFF',
    };
  },
};
</script>

<style scoped lang="scss">
@import "~@/styles/mobilemenu.scss";
</style>
